import type { SettingConst } from "@faire/web-api--source/types";

import { assignSetting } from "@faire/retailer/settings/__internal__/getSetting";

/**
 *
 * @param setting Setting provided from BE to assign as an XP
 */
export const assignSettingOnEvent = (setting: string | undefined) => {
  if (setting) {
    assignSetting(setting as SettingConst);
  }
};
